import React, { useState, useCallback, useEffect, useMemo } from 'react';

import NodeTree from './node';
import Tree from 'react-d3-tree';
import { add_icon_style } from 'views/IVR/form/tree/node/styles';

const DialogTreeComponent = ({ data = {} }) => {
  const [expandedNodes, setExpandedNodes] = useState([]);
  const [treeData, setTreeData] = useState([]);

  const shouldUseLazyLoad = useMemo(() => {
    const findMaxLevel = (node) => {
      if (!node || !node.nodes) return node?.level || 0;

      let maxLevel = node.level || 0;
      Object.values(node.nodes).forEach((childNode) => {
        const childMaxLevel = findMaxLevel(childNode);
        if (childMaxLevel > maxLevel) {
          maxLevel = childMaxLevel;
        }
      });

      return maxLevel;
    };

    const rootNode = data[Object.keys(data)[0]];
    if (!rootNode) return false;

    const maxLevel = findMaxLevel(rootNode);

    return maxLevel > 5;
  }, [data]);

  const formatToReactD3TreeNotLazy = (info) => {
    const nodeId = info?.nodeId ?? info?.id;
    const { ...restInfo } = info;

    const newData = {
      ...restInfo,
      nodeId,
      name: nodeId,
      action: info?.action ?? {},
      children:
        info?.nodes && Object.values(info?.nodes)?.length > 0
          ? Object.values(info?.nodes).map((item) =>
              formatToReactD3TreeNotLazy(item)
            )
          : [],
      _collapsed: false
    };

    return newData;
  };

  const formatToReactD3TreeLazy = (info) => {
    const nodeId = info?.nodeId ?? info?.id;
    const { ...restInfo } = info;
    const isExpanded = expandedNodes.includes(nodeId);
    let children = [];

    if (isExpanded) {
      children =
        info?.nodes && Object.values(info?.nodes)?.length > 0
          ? Object.values(info?.nodes).map((item) =>
              formatToReactD3TreeLazy(item)
            )
          : [];
    }

    return {
      ...restInfo,
      nodeId,
      name: nodeId,
      action: info?.action ?? {},
      children,
      _collapsed: false,
      hasLazyChildren:
        info?.nodes && Object.values(info?.nodes)?.length > 0 && !isExpanded
    };
  };

  const formatedDataNormal = useMemo(() => {
    const rootKey = Object.keys(data)[0];
    if (!rootKey || shouldUseLazyLoad) return null;
    return formatToReactD3TreeNotLazy(data[rootKey]);
  }, [data, shouldUseLazyLoad]);

  useEffect(() => {
    if (!shouldUseLazyLoad) return;

    const rootKey = Object.keys(data)[0];

    if (rootKey) {
      setTreeData([formatToReactD3TreeLazy(data[rootKey])]);
    }
  }, [data, expandedNodes, shouldUseLazyLoad]);

  const handleExpandClick = useCallback((nodeId) => {
    setExpandedNodes((prev) => {
      if (prev.includes(nodeId)) {
        return prev.filter((id) => id !== nodeId);
      } else {
        return [...prev, nodeId];
      }
    });
  }, []);

  const CustomNodeTreeLazy = (props) => {
    const { nodeData } = props;
    const isExpanded = expandedNodes.includes(nodeData.nodeId);
    const hasChildren =
      nodeData?.nodes && Object.values(nodeData?.nodes)?.length > 0;

    return (
      <div
        style={{ width: '100%', height: '100%', position: 'relative' }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <NodeTree {...props} />
        {hasChildren && (
          <i
            className={isExpanded ? 'fa fa-minus-circle' : 'fa fa-plus-circle'}
            style={{
              ...add_icon_style,
              left: '48%',
              bottom: '12px',
              transform: 'translateX(-50%)',
              borderRadius: '14px',
              background: 'white',
              cursor: 'pointer',
              color: isExpanded ? '#d9534f' : '#5cb85c',
              fontSize: '16px',
              border: `2px solid ${isExpanded ? '#d9534f' : '#5cb85c'}`,
              padding: '2px'
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleExpandClick(nodeData.nodeId);
            }}
            title={isExpanded ? 'Colapsar' : 'Expandir'}
          />
        )}
      </div>
    );
  };

  const dataToRender = shouldUseLazyLoad ? treeData : formatedDataNormal;
  const NodeComponent = shouldUseLazyLoad ? CustomNodeTreeLazy : NodeTree;

  return (
    <div id="treeWrapper" style={{ width: '100vw', height: '100vh' }}>
      {dataToRender && (shouldUseLazyLoad ? dataToRender.length > 0 : true) ? (
        <Tree
          data={shouldUseLazyLoad ? dataToRender : [dataToRender]}
          nodeSvgShape={{
            shape: 'rect',
            shapeProps: {
              width: 230,
              height: 110,
              x: -115,
              y: -50,
              fill: '#fafafa',
              stroke: '#dadada',
              strokeWidth: 1,
              rx: '12px',
              ry: '12px',
              backgroundColor: 'black'
            }
          }}
          orientation="vertical"
          pathFunc="step"
          collapsible={false}
          translate={{
            x: 500,
            y: 30
          }}
          separation={{
            siblings: 3,
            nonSiblings: 3
          }}
          nodeSize={{
            x: 130,
            y: 270
          }}
          styles={{
            links: {
              stroke: '#b9b9b9'
            }
          }}
          transitionDuration={0}
          allowForeignObjects={true}
          enableLegacyTransitions={false}
          nodeLabelComponent={{
            render: <NodeComponent />,
            foreignObjectWrapper: {
              x: -115,
              y: -50,
              height: 130,
              width: 240
            }
          }}
        />
      ) : (
        <div style={{ textAlign: 'center', padding: 40 }}>
          Nenhum dado para exibir
        </div>
      )}
    </div>
  );
};

export default DialogTreeComponent;
